export default __webpack_public_path__ + "static/media/rules-periodic-bg.4cfa9b08.jpg";